import { environment } from '../environments/environment';
// import { io } from 'socket.io-client';
import { Subject } from 'rxjs';
var io = require('socket.io-client');
var SocketioService = /** @class */ (function () {
    function SocketioService() {
        // Observable string sources
        this.componentMethodCallSource = new Subject();
        // Observable string streams
        this.caller = this.componentMethodCallSource.asObservable();
    }
    SocketioService.prototype.setupSocketConnection = function () {
        var _this = this;
        this.socket = io(environment.SOCKET_ENDPOINT);
        this.socket.emit('my message', 'Hello there from Angular.');
        this.socket.on('my broadcast', function (data) {
            console.log(data);
        });
        this.socket.on("noti", function (data) {
            _this.componentMethodCallSource.next(data);
        });
    };
    SocketioService.prototype.subscribe = function (newKey, oldKey) {
        var _this = this;
        if (oldKey) {
            this.socket.removeListener(oldKey);
        }
        this.socket.on(sessionStorage.getItem(newKey), function (data) {
            _this.componentMethodCallSource.next(data);
        });
    };
    return SocketioService;
}());
export { SocketioService };



// WEBPACK FOOTER //
// ./src/app/socketio.service.ts.pre-build-optimizer.js